import type { OverdueInfoResponse } from '@/types/credit';

export const selectIsOverdue = (overdueInfo: OverdueInfoResponse) => overdueInfo.totalOverdue.amount > 0;

export const selectOverdueInfoIfDiscountCategory = (
  overdueInfo: OverdueInfoResponse,
  discountCategory: OverdueInfoResponse['discountCategory'],
): OverdueInfoResponse | null =>
  selectIsOverdue(overdueInfo) && overdueInfo.discountCategory === discountCategory ? overdueInfo : null;

export const selectStandardOverdueInfo = (overdueInfo: OverdueInfoResponse) =>
  selectOverdueInfoIfDiscountCategory(overdueInfo, 'NO_DISCOUNT');

export const selectOverdueCampaignInfo = (overdueInfo: OverdueInfoResponse) =>
  selectOverdueInfoIfDiscountCategory(overdueInfo, 'OVERDUE_CAMPAIGN');

export const selectResetPaybackPlanInfo = (overdueInfo: OverdueInfoResponse) =>
  selectOverdueInfoIfDiscountCategory(overdueInfo, 'RESET_PAYBACK_PLAN');
